import { Dispatch, SetStateAction, createContext } from "react";
import { Referral } from "../../models";

export interface IReferralsContext {
    referral: Referral | undefined;
    setReferral: Dispatch<SetStateAction<Referral | undefined>>;
    isFetchingReferral: boolean;
    setIsFetchingReferral: Dispatch<SetStateAction<boolean>>;
    isSavingReferral: boolean;
    setIsSavingReferral: Dispatch<SetStateAction<boolean>>;
    isLocked: boolean;
    lockedByName: string;
    unlockReferral: (referralId: number | string) => Promise<void>;
}

const defaultValue: IReferralsContext = {
    referral: undefined,
    setReferral: () => {},
    isFetchingReferral: false,
    setIsFetchingReferral: () => {},
    isSavingReferral: false,
    setIsSavingReferral: () => {},
    isLocked: false,
    lockedByName: "",
    unlockReferral: async () => {},
};

export const ReferralsContext = createContext<IReferralsContext>(defaultValue);
ReferralsContext.displayName = "Referrals";
